const SwitzerlandSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112502)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#D80027"
      />
      <path
        d="M30.4345 16.522H23.478V9.56543H16.5214V16.522H9.56494V23.4785H16.5214V30.435H23.478V23.4785H30.4345V16.522Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112502">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SwitzerlandSvg;
